<div class="bloc">
  <div class="bloc-header">
    <div class="bloc-title">Configuration Beoogo</div>
  </div>
  <div class="env-selector">
    <label class="checkbox-item">
      <input type="checkbox" [(ngModel)]="form.isProduction" (ngModelChange)="onFieldChange()"/>
      <span class="checkmark"></span>
      <span>Production</span>
    </label>
    <span class="env-badge" [class.prod]="form.isProduction" [class.acc]="!form.isProduction">
      {{ form.isProduction ? 'PRD' : 'ACC' }}
    </span>
  </div>
  <div class="form-grid">
    <div class="form-field">
      <label class="form-label">Host <span class="required">*</span></label>
      <input type="text" class="form-input" placeholder="Host" required [(ngModel)]="form.host"
             (ngModelChange)="onFieldChange()"/>
    </div>
    <div class="form-field">
      <label class="form-label">SSO Host <span class="required">*</span></label>
      <input type="text" class="form-input" placeholder="SSO Host" required [(ngModel)]="form.ssoHost"
             (ngModelChange)="onFieldChange()"/>
    </div>
    <div class="form-field">
      <label class="form-label">Patient API <span class="required">*</span></label>
      <input type="text" class="form-input" placeholder="Patient API" required [(ngModel)]="form.patientApi"
             (ngModelChange)="onFieldChange()"/>
    </div>
    <div class="form-field">
      <label class="form-label">Patient URL <span class="required">*</span></label>
      <input type="text" class="form-input" placeholder="Patient URL" required [(ngModel)]="form.patientUrl"
             (ngModelChange)="onFieldChange()"/>
    </div>
    <div class="form-field">
      <label class="form-label">SSO API <span class="required">*</span></label>
      <input type="text" class="form-input" placeholder="SSO API" required [(ngModel)]="form.ssoApi"
             (ngModelChange)="onFieldChange()"/>
    </div>
    <div class="form-field">
      <label class="form-label">Client ID <span class="required">*</span></label>
      <input type="text" class="form-input" placeholder="Client ID" required [(ngModel)]="form.clientId"
             (ngModelChange)="onFieldChange()"/>
    </div>
    <div class="form-field">
      <label class="form-label">Client Secret <span class="required">*</span></label>
      <input type="text" class="form-input" placeholder="Client Secret" required [(ngModel)]="form.clientSecret"
             (ngModelChange)="onFieldChange()"/>
    </div>
    <div class="form-field">
      <label class="form-label">Nom d'utilisateur <span class="required">*</span></label>
      <input type="text" class="form-input" placeholder="Nom d'utilisateur" required [(ngModel)]="form.userName"
             (ngModelChange)="onFieldChange()"/>
    </div>
    <div class="form-field">
      <label class="form-label">Mot de passe <span class="required">*</span></label>
      <input type="password" class="form-input" placeholder="Mot de passe" required [(ngModel)]="form.password"
             (ngModelChange)="onFieldChange()"/>
    </div>
  </div>
</div>
